import keyMirror from 'keymirror';

const FARE_FAMILIES_NAMES = {
  BASIC: 'COACH_BA',
  BASICLIGHT: 'COACH_BA_LIGHT',
  CLASSIC: 'COACH_CL',
  FLEXIBLE: 'COACH_FL',
  AMPLUS: 'COACH_AM',
  COMFORT: 'FIRST_CL',
  CONFORT: 'FIRST_CL',
  PREMIER: 'FIRST_FL',
  NA: 'NA', // Default para vuelos operados por otras aerolineas
};

const FARE_TYPES = keyMirror({
  COACH_EC: null,
  COACH_CL: null,
  COACH_FL: null,
  FIRST_CL: null,
  FIRST_FL: null,
});

const FARE_TYPES_DOMESTIC = keyMirror({
  COACH_EC: null,
  COACH_CL: null,
  COACH_FL: null,
  COACH_AM: null,
  FIRST_FL: null,
});

const FARE_TYPES_TRANSBORDER = keyMirror({
  COACH_EC: null,
  COACH_CL: null,
  COACH_AM: null,
  FIRST_CL: null,
  FIRST_FL: null,
});

const FARE_TYPES_INTERNATIONAL = keyMirror({
  COACH_EC: null,
  COACH_CL: null,
  COACH_FL: null,
  FIRST_CL: null,
  FIRST_FL: null,
});

const MULTI_CITY_FARE_TYPES = keyMirror({
  COACH_EC: null,
  FIRST_FL: null,
});

const FARE_TYPES_LIST_BRANDED_BENEFITS = {
  BASIC: {
    fareID: 'BASICA',
    isFlexible: false,
  },
  BASICLIGHT: {
    fareID: 'BASICA_LIGHT',
    isFlexible: false,
  },
  CLASSIC: {
    fareID: 'CLASICA',
    isFlexible: false,
  },
  AMPLUS: {
    fareID: 'AMPLUS',
    isFlexible: false,
  },
  COMFORT: {
    fareID: 'COMFORT',
    isFlexible: false,
  },
  PREMIER: {
    fareID: 'PREMIER',
    isFlexible: false,
  },
};
export default {
  FARE_FAMILIES_NAMES,
  FARE_TYPES,
  FARE_TYPES_DOMESTIC,
  FARE_TYPES_TRANSBORDER,
  FARE_TYPES_INTERNATIONAL,
  FARE_TYPES_LIST_BRANDED_BENEFITS,
  MULTI_CITY_FARE_TYPES,
};
